export const payments = {
  'payments.receive.title': 'استلام دفعة',
  'payments.receive.subtitle': 'وصل واحد يغطي الإخوة',
  'payments.search.label': 'ولي الأمر',
  'payments.search.placeholder': 'ابحث باسم ولي الأمر أو رقم هاتفه',
  'payments.search.hint': 'اكتب حرفين على الأقل من الاسم أو أرقاماً من الهاتف.',
  'payments.search.none': 'لا يوجد ولي أمر مطابق',
  'payments.search.children': '{names}',
  'payments.search.startTitle': 'ابدأ بالبحث عن العائلة',
  'payments.search.startBody': 'يظهر كل أبناء ولي الأمر مع المتبقي على كل منهم، ويُسجَّل وصل واحد للعائلة.',
  'payments.family.change': 'تغيير العائلة',
  'payments.family.total': 'إجمالي المتبقي',
  'payments.family.noChildren': 'لا يوجد أبناء مسجّلون لولي الأمر هذا.',
  'payments.family.notPayer': 'ليس الدافع المعتاد',
  'payments.child.net': 'الرسوم بعد الخصم',
  'payments.child.paid': 'المدفوع',
  'payments.child.balance': 'المتبقي',
  'payments.child.amount': 'المبلغ لهذا الطالب',
  'payments.child.fillDue': 'القسط',
  'payments.child.fillAll': 'كامل المتبقي',
  'payments.child.overdue': 'متأخر {amount}',
  'payments.child.next': 'القسط القادم {date}',
  'payments.child.paidUp': 'مسدّد بالكامل',
  'payments.child.credit': 'رصيد دائن {amount}',
  'payments.child.over': 'المبلغ أكبر من المتبقي؛ الفرق يصبح رصيداً دائناً.',
  'payments.method': 'طريقة الدفع',
  'payments.ref.CARD': 'رقم إيصال جهاز البطاقة',
  'payments.ref.TRANSFER': 'رقم الحوالة',
  'payments.ref.CHEQUE': 'رقم الصك واسم المصرف',
  'payments.ref.WALLET': 'رقم العملية',
  'payments.ref.required': 'رقم المرجع مطلوب لغير النقد',
  'payments.pendingNote': 'تُسجَّل «بانتظار التسوية» حتى يُؤكَّد وصول المبلغ إلى الحساب.',
  'payments.account': 'الحساب',
  'payments.paper.toggle': 'سُجّلت على وصل ورقي (انقطاع الكهرباء أو الإنترنت)',
  'payments.paper.no': 'رقم الوصل الورقي',
  'payments.paper.date': 'تاريخ الوصل الورقي',
  'payments.paper.hint': 'يُحفظ الرقم الورقي مع الوصل، ويأخذ الوصل تاريخ الدفتر.',
  'payments.note': 'ملاحظة',
  'payments.total': 'المجموع',
  'payments.save': 'حفظ وطباعة الوصل',
  'payments.saveHint': 'يُعطى رقم الوصل بعد الحفظ.',
  'payments.nothing': 'أدخل مبلغاً لطالب واحد على الأقل.',
  'payments.saved': 'سُجّل الوصل {no}',
  'payments.retrySafe': 'لم يُحفظ الوصل. أعد المحاولة؛ الحفظ آمن ولن يُسجَّل المبلغ مرتين.',
  'payments.receipt.title': 'وصل قبض',
  'payments.receipt.reversalTitle': 'قيد عكسي',
  'payments.receipt.no': 'رقم الوصل',
  'payments.receipt.paper': 'وصل ورقي رقم {no}',
  'payments.receipt.receivedFrom': 'استلمنا من',
  'payments.receipt.method': 'طريقة الدفع',
  'payments.receipt.reference': 'المرجع',
  'payments.receipt.student': 'الطالب',
  'payments.receipt.words': 'المبلغ كتابةً',
  'payments.receipt.receivedBy': 'المستلم',
  'payments.receipt.account': 'الحساب',
  'payments.receipt.printA5': 'طباعة A5',
  'payments.receipt.printThermal': 'طباعة حرارية 80 مم',
  'payments.receipt.reverses': 'يعكس الوصل {no}',
  'payments.receipt.reversedBy': 'عُكس بالقيد {no}',
  'payments.receipt.signature': 'التوقيع',
  'payments.receipt.pending': 'بانتظار التسوية — لا يُعدّ مُحصّلاً حتى يصل المبلغ.',
  'payments.list.title': 'المدفوعات',
  'payments.list.subtitle': 'الوصولات والتحويلات والقيود العكسية',
  'payments.list.tab.all': 'الكل',
  'payments.list.tab.PENDING': 'بانتظار التسوية',
  'payments.list.tab.CLEARED': 'مُحصّلة',
  'payments.list.tab.BOUNCED': 'مرتجعة',
  'payments.list.tab.REVERSED': 'معكوسة',
  'payments.list.date': 'اليوم',
  'payments.list.anyDate': 'كل الأيام',
  'payments.list.account': 'الحساب',
  'payments.list.allAccounts': 'كل الحسابات',
  'payments.list.col.receipt': 'الوصل',
  'payments.list.col.date': 'التاريخ',
  'payments.list.col.payer': 'الدافع',
  'payments.list.col.students': 'الطلاب',
  'payments.list.col.method': 'الطريقة',
  'payments.list.empty': 'لا توجد مدفوعات',
  'payments.list.emptyBody': 'لا توجد وصولات تطابق التصفية.',
  'payments.list.pendingEmpty': 'لا توجد تحويلات أو صكوك بانتظار التسوية',
  'payments.list.pendingHelp': 'أكّد وصول المبلغ عند ظهوره في كشف المصرف، أو سجّله مرتجعاً إن رُفض الصك أو لم تصل الحوالة.',
  'payments.action.clear': 'تأكيد الوصول',
  'payments.action.bounce': 'مرتجع',
  'payments.action.reverse': 'عكس الوصل',
  'payments.action.print': 'طباعة',
  'payments.clear.title': 'تأكيد وصول المبلغ',
  'payments.clear.body': 'يُحتسب الوصل مُحصّلاً ويدخل المبلغ رصيد «{account}» بتاريخ اليوم.',
  'payments.clear.done': 'أُكّد وصول المبلغ',
  'payments.bounce.title': 'تسجيل الوصل مرتجعاً',
  'payments.bounce.body': 'الصك رُفض أو الحوالة لم تصل: يُلغى أثر الوصل {no} على أرصدة الطلاب.',
  'payments.bounce.note': 'السبب (مثلاً: صك بلا رصيد)',
  'payments.bounce.done': 'سُجّل الوصل مرتجعاً',
  'payments.reverse.title': 'عكس الوصل',
  'payments.reverse.body': 'يُسجَّل قيد عكسي (RV) بالمبلغ نفسه بالسالب؛ الوصل الأصلي لا يُعدَّل ولا يُحذف.',
  'payments.reverse.reason': 'سبب العكس',
  'payments.reverse.done': 'سُجّل القيد العكسي {no}',
  'payments.detail.title': 'الوصل {no}',
  'payments.detail.reversalTitle': 'القيد العكسي {no}',
  'payments.detail.back': 'كل المدفوعات',
  'payments.detail.students': 'الطلاب',
  'payments.detail.note': 'ملاحظة',
  'payments.detail.recordedAt': 'سُجّل في ',
  'payments.me': 'أنت',
  'payments.otherUser': 'مستخدم آخر',
  'payments.clear.bodyNoAccount': 'يُحتسب الوصل مُحصّلاً ويدخل المبلغ الحساب المصرفي بتاريخ اليوم.',
  'payments.receipt.refundedTo': 'رُدّ إلى',
  'payments.receipt.recordedBy': 'سجّله',
  'payments.detail.clearedBy': 'أكّد الوصول: {name}',
  'payments.list.from': 'من تاريخ',
  'payments.list.to': 'إلى تاريخ',
  'payments.list.search': 'ابحث برقم الوصل أو الوصل الورقي أو اسم الدافع أو المرجع',
} as const;
